import type { FaireProductEntity } from "../../entity_types/product";

export const p_ku98jqh964: FaireProductEntity = {
  token: "p_ku98jqh964",
  type: "product",
  name: "Organic Waffle Gown, Black Heart",
  brandToken: "b_4ivwmhbmyd",
  brandName: "SpearmintLOVE",
  imageUrl:
    "https://cdn.faire.com/fastly/afcda3ec7fe2f77bef70aefdd1d942ef891819457f5063eb17a38d94920b6b27.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/36a71d41fc36dd2a28bbc9b410b3c6b85624de789f9d922430f6320bc084e35a.jpeg",
    "https://cdn.faire.com/fastly/4480357fc449f1397f0ad308b7586fe70c767cc78751c22d090176f3e70d266b.png",
  ],
  priceDollars: 12,
  description:
    "Dress your little one in comfort and style with the Organic Waffle Gown. Made from ultra-soft, 100% organic cotton, this gown provides the perfect combination of warmth, breathability, and stretch for newborns and infants. \n\nDesigned with your baby’s comfort in mind, the gown features a soft elasticized hem, making it easy for quick diaper changes and allowing your little one to stretch and move freely. The fold-over cuffs keep tiny hands warm and prevent scratching, while the gentle organic fabric ensures it’s safe and gentle against delicate skin.\n\nFeatures:\n\n * Material: 100% Organic Cotton (soft, breathable, and safe for baby’s skin) \n * Size & Fit: Recommended for 0-3 mo. \n * Elasticized Hem: For easy diaper changes and a snug, comfy fit \n * Fold-over Cuffs: Protect baby’s hands and keep them warm \n * Eco-friendly: Made with sustainably sourced, organic cotton \n * Easy Care: Machine washable cold, lay flat to dry \nWhether for day-to-day wear or as part of a thoughtful gift for new parents, this gown offers the perfect blend of functionality, comfort, and style.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:13.254Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
